
(function ($) {
  function executeFunction() {
    if(window.designated_buy_gift_function){
      custom.designatedBuyGift();
    }
    if(window.full_amount_buy_gift_function){
      if(window.designated_buy_gift_function){
        setTimeout(() => {
          custom.fullamountBuyGift();
        }, 100);
      }else{
        custom.fullamountBuyGift();
      }

    }

  }

  // 创建代理
  var carthandler = {
    set(target, property, value) {
      // 监控 isActive 属性的变化
      if (property === 'isActive') {
        // 如果值变为 true，执行函数
        if (value === true) {
          executeFunction();
        }
      }
      // 设置属性值
      target[property] = value;
      return true;
    }
  };

  window.cart_proxy = new Proxy(window.CartChangetarget, carthandler);
  $(document).ready(function () {
    custom.init();
  });

  var custom = {
    init: function () {
    if(window.designated_buy_gift_function){
        this.designatedBuyGift();
      }
    if(window.full_amount_buy_gift_function){
        this.fullamountBuyGift();
      }

    },
  disable_checkout: function(){
    $(".cart__checkout-button").attr("disabled","disabled").addClass("loading");
      $(".cart__checkout-button .loading__spinner").removeClass("hidden");
      $(".gift-item")?.addClass("loading");
    },
  open_checkout: function(){
      $(".cart__checkout-button").removeAttr("disabled").removeClass("loading");
      $(".cart__checkout-button .loading__spinner").addClass("hidden");
      $(".gift-item")?.removeClass("loading");
    },
    formatPrice(priceInCents, currencyCode, decimalDigits) {
      const price = priceInCents / 100;
      // 定义不同货币的特性
      const currencyInfo = {
        'USD': { locale: 'en-US' }, // 美元
        'EUR': { locale: 'de-DE' }, // 欧元
        'JPY': { locale: 'ja-JP' }, // 日元
        'GBP': { locale: 'en-GB' }, // 英镑
        'AUD': { locale: 'en-AU' }, // 澳元
        // 可以根据需要添加更多货币
      };

      // 获取货币信息，默认使用 USD 的设置
      const { locale } = currencyInfo[currencyCode] || currencyInfo['USD'];

      // 确定小数位数
      let finalDecimalDigits;
      if (decimalDigits !== undefined) {
        finalDecimalDigits = decimalDigits; // 使用自定义小数位数
      } else {
        finalDecimalDigits = Number.isInteger(price) ? 0 : 2; // 默认：整数无小数，小数使用2位
      }

      // 使用 Intl.NumberFormat 格式化价格
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: finalDecimalDigits,
        maximumFractionDigits: finalDecimalDigits,
      }).format(price);
    },
    freegift_Tips_section(curr_level, subtotal_Price) {
      // console.log("freegift_Tips_section");
      // console.log("currlevel,subtotalPrice : " + curr_level + "," + subtotal_Price);
      let imagePath, tips_text, adding_tips, price_diff, last_point, second_point, valuenow, second_position, next_level, curr_giftName, next_giftName, curr_fullamount, next_fullamount, curr_imagePath, next_imagePath, first_point, total_Level, second_html, curr_point;
      next_level = parseInt(curr_level) + 1;
      second_html = ``;
      first_point = custom.formatPrice(0, window.active_currency);
      curr_point = custom.formatPrice(subtotal_Price, window.active_currency);
      total_Level = parseInt(document.querySelectorAll('.fullamount-item').length);
      if (curr_level == 0) {
        curr_giftName = $(`.fullamount-item[data-level='${next_level}']`).attr("data-gift-name");
        curr_fullamount = $(`.fullamount-item[data-level='${next_level}']`).attr("data-fullamount") * window.active_currency_rate;
        curr_imagePath = $(`.fullamount-item[data-level='${next_level}']`)?.attr("data-gift-image");
      } else if (curr_level == total_Level) {
        curr_fullamount = $(`.fullamount-item[data-level='${total_Level}']`).attr("data-fullamount") * window.active_currency_rate;
        curr_imagePath = $(`.fullamount-item[data-level='${total_Level}']`)?.attr("data-gift-image");
        curr_giftName = $(`.fullamount-item[data-level='${total_Level}']`).attr("data-gift-name");
        for (var i = 1; i < total_Level; i++) {
          let tempFullAmount = $(`.fullamount-item[data-level='${i}']`).attr("data-fullamount") * window.active_currency_rate;
          second_point = custom.formatPrice(tempFullAmount, window.active_currency);
          second_position = tempFullAmount / curr_fullamount * 100 - 5 + '%';
          second_html = second_html + `<span class="second-point" style="left:${second_position}">${second_point}</span>`;
        }
      } else {
        curr_giftName = $(`.fullamount-item[data-level='${curr_level}']`).attr("data-gift-name");
        next_giftName = $(`.fullamount-item[data-level='${next_level}']`).attr("data-gift-name");
        curr_fullamount = $(`.fullamount-item[data-level='${curr_level}']`).attr("data-fullamount") * window.active_currency_rate;
        next_fullamount = $(`.fullamount-item[data-level='${next_level}']`).attr("data-fullamount") * window.active_currency_rate;
        curr_imagePath = $(`.fullamount-item[data-level='${curr_level}']`)?.attr("data-gift-image");
        next_imagePath = $(`.fullamount-item[data-level='${next_level}']`)?.attr("data-gift-image");
      }


      // console.log("curr_level:" + curr_level);
      // console.log("first_point");
      // console.log("next_level: " + next_level + " ,total_Level: " + total_Level);
      // console.log("curr_fullamount:" + curr_fullamount);
      if (next_level <= total_Level) {
        // 当前非最高梯度
        if (subtotal_Price >= curr_fullamount) {
          // 总价大于梯度金额
          // console.log("second level");
          price_diff = custom.formatPrice((next_fullamount - subtotal_Price), window.active_currency, 2);
          imagePath = next_imagePath;
          tips_text = `You've unlocked free ${curr_giftName}`;
          adding_tips = `Add ${price_diff} to unlock free ${next_giftName}!`
          second_point = custom.formatPrice(curr_fullamount, window.active_currency);
          second_position = curr_fullamount / next_fullamount * 100 - 5 + '%';
          second_html = `<span class="second-point" style="left:${second_position}">${second_point}</span>`;
          last_point = custom.formatPrice(next_fullamount, window.active_currency, 0);
          valuenow = subtotal_Price / next_fullamount * 100 + '%';

        } else {
          // 总价小于梯度金额
          // console.log("first level");
          price_diff = custom.formatPrice((curr_fullamount - subtotal_Price), window.active_currency, 2);
          imagePath = curr_imagePath;
          tips_text = `Add ${price_diff} to unlock free ${curr_giftName}!`
          last_point = custom.formatPrice(curr_fullamount, window.active_currency, 0);
          valuenow = subtotal_Price / curr_fullamount * 100 + '%';
        }
      }
      else {
        // 已是最高梯度
        // console.log("higer level");
        imagePath = curr_imagePath;
        tips_text = `You've unlocked free ${curr_giftName}`
        last_point = custom.formatPrice(curr_fullamount, window.active_currency, 0);
        valuenow = '100%';
      }

      const htmlContent = `
                <div class=" products-grid freegift-box ">
                <div class="grid-item cart-freegift-container">
                    <div class="freegift-image-container ">
                    <img src="${imagePath}" alt=""  loading="lazy" width="200" height="260" ></div>
                    <div class="freegift-progress-container">
                        <div role="status">
                          ${tips_text ? `<p class="tips-text">${tips_text}</p>` : ''}
                          ${adding_tips ? `<p class="adding-tips">${adding_tips}</p>` : ''}
                          <p class="only-tips">(Only one free gift is eligible for each order, not both.)</p>
                        </div>
                        <div class="gift_progress" aria-label="Free gift progress bar" role="progressbar" aria-valuenow="${curr_point >= last_point ? last_point : curr_point}" aria-valuemin="${first_point}" aria-valuemax="${last_point}" aria-busy="false">         
                            <div class="gift_probar" style="width:${valuenow}">
                                <span class="icon-gift" aria-hidden="true"></span>
                                </div>       
                            <span class="first-point">
                            ${first_point}
                            </span>
                            ${second_html ? `${second_html}` : ''}
                            <span class="last-point">
                            ${last_point}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        `;
      const dawerhtmlContent = `
            <div class="grid-item col-12 text-center freegift-function-title" role="status"> 
              ${adding_tips ? `<p class="adding-tips">${adding_tips}</p>` : tips_text ? `<p class="tips-text">${tips_text}</p>` : ''}               
              <p>(Only one free gift is eligible for each order)</p>
            </div>
            <div class="grid-item col-12">
              <div class="gift_progress" aria-label="Free gift progress bar" role="progressbar" aria-valuenow="${curr_point >= last_point ? last_point : curr_point}" aria-valuemin="${first_point}" aria-valuemax="${last_point}" aria-busy="false">
                  <div class="gift_probar" style=" width:${valuenow} ">
                      <span class="visually-hidden">${curr_point >= last_point ? last_point : curr_point}</span>
                  </div>
                  <span class="first-point">
                  ${first_point}
                  </span>
                  <span class="last-point">
                  ${last_point}
                  </span>
              </div>
            </div>
        `;

      let local = window.location.href;
      if (local.indexOf("/cart") > 0) {
        $(".cart-freegift-content-2").html(htmlContent);
      }
      $(".drawer-freegift-tips").html(dawerhtmlContent);
    },
    updateGift: function(gifobj){      
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
      data: {updates: gifobj},
        dataType: 'json',
      success: function(cart) {
          custom.updateCartContent(cart);
        },
        error: function (xhr) {
          if(xhr.responseText){
            console.log(xhr.responseText);
          }
          window.location.reload();
        }
      });
    },
  addGift: function(giftobj){
      $.ajax({
        async: false,
        type: "post",
        url: "/cart/add.js",
        data: giftobj,
        dataType: 'json',
        success: function(cart) {
          // console.log("addGift");
          custom.updateCartContent(cart);
        },
        error: function (xhr) {
            if(xhr.responseText){
            console.log(xhr.responseText);
          }
          window.location.reload();
        },
        complete: function () {

        }
      });
    },
  changeGift: function(giftobj){
      $.ajax({
        async: false,
        type: "post",
        url: "/cart/change.js",
        data: giftobj,
        dataType: 'json',
        success: function(cart) {
          // console.log("changegift");
          custom.updateCartContent(cart);
        },
        error: function (xhr) {
            if(xhr.responseText){
            console.log(xhr.responseText);
          }
          window.location.reload();
        },
        complete: function () {

        }
      });
    },
  clearCart: function() {
      $.ajax({
        async: false,
        type: "post",
        url: "/cart/clear.js",
        dataType: 'json',
        success: (cart)=>{
          // console.log("clearcart");
          custom.updateCartContent(cart);
        },
        error: function (xhr, textStatus, errorMsg) {
          if(xhr.responseText){
            console.log(xhr.responseText);
          }
          window.location.reload();
        },
        complete: function () {

        }
      });
    },
    updateCartDrawerInfo:function() {
      fetch(`${routes.cart_url}`).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['.cart-count-bubble', '.drawer__header', '.sider-cart-top-count', '.drawer__inner-empty', 'cart-drawer-items', '.cart-drawer__footer', '.cart-items-js-contents', '.subtotal-content', '#cart-empty .js-contents'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      }).catch((e) => {
        console.error(e);
        window.location.reload();
      });
    },
    updateCartContent :function(cart){
      // console.log("updateCartContent");
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      let local = window.location.href;
      const cart_count =cart.item_count;
      if(cart_count == 0){
        $('.cartCount').html(`<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} item(s)</span>`);         
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', cart.item_count === 0);
          if(local.indexOf("/cart") > 0){
            const cartitemlist = document.getElementById('main-cart-items');
            const cartFooter = document.getElementById('main-cart-footer');
            const CartEmptySection = document.getElementById('cart-empty');
            const cartbestsellerSection = document.getElementById('cart-bestseller');
            if (cartitemlist) cartitemlist.classList.toggle('is-empty', cart.item_count === 0);
            if (cartFooter) cartFooter.classList.toggle('is-empty', cart.item_count === 0);
            if(cartbestsellerSection) cartbestsellerSection.classList.toggle('is-empty', cart.item_count === 0);
            if(CartEmptySection) CartEmptySection.classList.toggle('hidden', cart.item_count != 0);
          }
          custom.updateCartDrawerInfo();
      }else{
        custom.disable_checkout();
        custom.updateCartDrawerInfo();
        custom.open_checkout();
        jQuery.getJSON('/cart.js', function(cart) {
          // console.log(cart.item_count);
          let idToCheck="";
          let have_giftincartFlag = false;
          if(cart.item_count== 1){ 
            idToCheck = String(cart.items[0].id); 
            have_giftincartFlag = window.full_amount_gift_group.indexOf(idToCheck) !== -1  || window.designated_buy_gift_group.indexOf(idToCheck) !== -1;
          }         
        if(cart.item_count== 1 && have_giftincartFlag){
          custom.clearCart();
        }else{      
                   
          $('.cartCount').html(`<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} item(s)</span>`);       
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', cart.item_count === 0);
          if(local.indexOf("/cart") > 0){
            const cartitemlist = document.getElementById('main-cart-items');
            const cartFooter = document.getElementById('main-cart-footer');
            const CartEmptySection = document.getElementById('cart-empty');
            const cartbestsellerSection = document.getElementById('cart-bestseller');
            if (cartitemlist) cartitemlist.classList.toggle('is-empty', cart.item_count === 0);
            if (cartFooter) cartFooter.classList.toggle('is-empty', cart.item_count === 0);
            if(cartbestsellerSection) cartbestsellerSection.classList.toggle('is-empty', cart.item_count === 0);
            if(CartEmptySection) CartEmptySection.classList.toggle('hidden', cart.item_count != 0);
          }
          if(window.full_amount_buy_gift_function){custom.fullamountBuyGift();}  
        }
        });    
      }
      },
  designatedBuyGift:function(){
    // console.log("designatedBuyGift");
    if($(`.buy-gift-item`).length) {
        custom.disable_checkout();
        $(`.buy-gift-item`).each(function(){
            if($(this).hasClass(`only-one-gift`)){
            var designateIdArr = $(this).attr(`data-id`).split(`,`);
            var giftId = parseInt($(this).attr(`data-gift-id`));
            var giftObj = {};
            var giftRemoveObj = {};
                var giftavailableID= parseInt($(this).attr(`data-gift-variant`));
                // console.log("giftavailableID: "+ giftavailableID);
                if($(`cart-drawer-items .cart-items [data-product-id="${giftId}"]`).length){
              let tempVariantId = parseInt($(`cart-drawer-items .cart-items [data-product-id="${giftId}"]`).attr(`data-idth`));
                    if(tempVariantId != giftavailableID) {giftRemoveObj = {id: tempVariantId, quantity: 0}}
                }else{
                    giftObj = {id: giftavailableID ,quantity: 1};
                    giftRemoveObj = {id: giftavailableID ,quantity: 0}
            }
                // console.log("giftObj  : ",giftObj);
                // console.log("giftRemoveObj : ",giftRemoveObj);

                jQuery.getJSON('/cart.js', function(cart) {
              var cartItems = cart.items;
              var hadDesignated = false;
              var hasGift = false;
              var giftNums = 0;
              cartItems.forEach(item => {
                let itemProId = item.product_id;
                        if(designateIdArr.indexOf(itemProId.toString()) != -1) {hadDesignated = true;}
                        if(itemProId == giftId) {hasGift = true;giftNums += item.quantity;}
              });
              // console.log(hadDesignated,hasGift,giftNums);
                    if(hadDesignated && hasGift && giftNums == 1){
                custom.open_checkout();
                return;
              }
                    if(hadDesignated && hasGift && giftNums != 1){
                      giftObj = {id: giftavailableID ,quantity: 1};
                      // console.log(giftObj);
                      custom.changeGift(giftObj);
              }
                    if(hadDesignated && !hasGift) {
                    custom.addGift(giftObj);
              }
                    if(!hadDesignated && hasGift) {                   
                      giftRemoveObj = {id: giftavailableID ,quantity: 0}
                      // console.log(giftRemoveObj);
                custom.changeGift(giftRemoveObj);
              }             
                    if(!hadDesignated && !hasGift){
                custom.open_checkout();
              }            
            });
            }else {
            var designateIdArr = $(this).attr(`data-id`).split(`,`);
                var giftavailableID= parseInt($(this).attr(`data-gift-variant`));
            var giftId = parseInt($(this).attr(`data-gift-id`));
            var giftObj = {};
            var giftRemoveObj = {};
            var tempObj = {};
                jQuery.getJSON('/cart.js', function(cart) {
              var cartItems = cart.items;
              var designatedNums = 0;
              var giftNums = 0;
              cartItems.forEach(item => {
                let itemProId = item.product_id;
                        if(designateIdArr.indexOf(itemProId.toString()) != -1) {designatedNums += item.quantity;}
                        if(itemProId == giftId) {giftNums += item.quantity;}
              });
             
              // console.log("mult group 2 ",designatedNums,giftNums);
                    if($(`cart-drawer-items .cart-items [data-product-id="${giftId}"]`).length){
                let tempVariantId = parseInt($(`cart-drawer-items .cart-items [data-product-id="${giftId}"]`).attr(`data-idth`));
                if (tempVariantId != giftavailableID) {
                  giftRemoveObj = { id: tempVariantId, quantity: 0 }
                } else {
                  giftObj = { id: giftavailableID, quantity: designatedNums };
                  giftRemoveObj = { id: giftavailableID, quantity: 0 }
                }
              } else {
                giftObj = { id: giftavailableID, quantity: designatedNums };
                giftRemoveObj = { id: giftavailableID, quantity: 0 }
              }

              if(designatedNums == 0 && giftNums == 0){
                custom.open_checkout();
                return;
              }
                    if(designatedNums > 0 && designatedNums == giftNums){
                custom.open_checkout();
                return;
              }
                    if(designatedNums>0 && giftNums==0) {

                custom.addGift(giftObj);
              }
                    if(giftNums>0 && designatedNums != giftNums) { 
                      // console.log("giftNums>0 && designatedNums != giftNums"); 
                      custom.updateCartContent(cart);                
                      tempObj[giftavailableID] = designatedNums;
                      let tempkey;
                      $.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                      data: {updates: tempObj},
                        dataType: 'json',
                      success: function(cart) {
                                // console.log("tempkey update item");
                                if(cart.item_count != 0 ){
                                  cart.items.forEach((item) => {
                                    let itemProId = item.product_id;
                                    let itemdiscountprice = item.discounted_price;
                                    let itemKey1 = item.key;
                                    if (itemProId == giftId && itemdiscountprice != 0) {
                                      tempkey = itemKey1;
                                    }
                                  });    
                                  // console.log(tempkey);                     
                                  if(typeof(tempkey) == 'string' && tempkey.length != 0){
                                    let tempobj2 = {'id': tempkey,'quantity': 0};
                                    setTimeout(() => {
                                      $.ajax({
                                        async: false,
                                        type: "post",
                                        url: "/cart/change.js",
                                        data: tempobj2,
                                        dataType: 'json',
                                        success: function(cart) {
                                          custom.updateCartContent(cart);
                                          if(window.full_amount_buy_gift_function){custom.fullamountBuyGift();}                                 
                                        },
                                        error: function (xhr) {
                                            if(xhr.responseText){
                                            console.log(xhr.responseText);
                                          }
                                          
                                        },
                                        complete: function () {
                                
                                        }
                                      });
                                    }, 100);
                  
                                  }else{
                                    custom.updateCartContent(cart);
                                
                                  }
                                  if(window.full_amount_buy_gift_function){
                                    setTimeout(() => {
                                      custom.fullamountBuyGift();
                                    }, 200);
                                  }  
                                }

                        },
                        error: function (xhr) {
                          if(xhr.responseText){
                            console.log(xhr.responseText);
                          }
                          window.location.reload();
                        }
                      });
              }

            });
          }
        });

      }
    },
  fullamountBuyGift:function(){
      if($(`.fullamount-item`).length > 0){
        custom.disable_checkout();
      jQuery.getJSON('/cart.js', function(cart) {
          var fullamountLen = $(`.fullamount-item`).length;
          var fullNTCArr = window.pro_ntc_idlist ? window.pro_ntc_idlist : [];
          var fullGiftIdArr = [];
          var giftInCartArr = [];
          var subtotalPrice = 0;
          var currlevel = 0;
          var cartItems = cart.items;
          var hasGift = false;
          var idToCheck2="";     
          var temp_key; 
          for(var i = 0; i< fullamountLen; i++) {
            let tempId = parseInt($(`.fullamount-item`).eq(i).attr(`data-gift-id`));
            fullGiftIdArr.push(tempId);
          }
          // 计算总价 & 判断是否有gift在cart中

          cartItems.forEach(item => {
              if(fullGiftIdArr.indexOf(item.product_id) == -1 && fullNTCArr.indexOf(item.product_id) == -1) {subtotalPrice += item.final_line_price;}
              if(fullGiftIdArr.indexOf(item.product_id) != -1) {hasGift=true; giftInCartArr.push(item.product_id);}
          });
          $(`.fullamount-item`).each(function(){
            let tempPrice = parseInt($(this).attr(`data-fullamount`)) * window.active_currency_rate;
            // console.log("tempPrice"+ tempPrice);
            if(subtotalPrice >= tempPrice){
              currlevel = parseInt($(this).attr(`data-level`));
            }
          });
          //  console.log(subtotalPrice);
          //  console.log(currlevel+","+hasGift+","+ giftInCartArr.length);
          //  console.log(giftInCartArr);
          //  console.log(cart.item_count);
          //  console.log(cart.items);
          if(cart.items.length == 1 && hasGift) {
            // 如果Cart中只有gift, 清空购物车
            custom.clearCart();
          }else if(currlevel > 0) {
              if(hasGift) {
              // 有gift在cart中，判断是否是需要加购的gift，若是则不作操作；否则先移除 再加购需要加购的gift
              var fullgiftId = parseInt($(`.fullamount-item[data-level="${currlevel}"]`).attr(`data-gift-id`));
              var fullgiftAvaiId = $(`.fullamount-item[data-level="${currlevel}"]`).attr("data-gift-variant");
              var fullupdatesObj = {};
              // cart中可能存在多个gift或1个gift，则判断是否符合等级条件的gift，如果不符合则删除
                  giftInCartArr.forEach(function(giftInCartId) {
                    if(giftInCartId != fullgiftId){
                    if($(`cart-drawer-items .cart-items [data-product-id="${giftInCartId}"]`).length){
                    let tempVariantId = parseInt($(`cart-drawer-items .cart-items [data-product-id="${giftInCartId}"]`).attr(`data-idth`));
                      if(tempVariantId != fullgiftAvaiId) {
                      fullupdatesObj[tempVariantId] = 0;
                    }
                  }
                }
              });
              cart.items.forEach((item) => {
                let itemProId = item.variant_id;
                let itemdiscountprice = item.discounted_price;
                let itemKey1 = item.key;
                if (itemProId == fullgiftAvaiId && itemdiscountprice != 0) {
                  temp_key = itemKey1;
                }
              });   
              if(typeof(temp_key) == 'string' && temp_key.length != 0){
                let tempobj = {'id': temp_key,'quantity': 0};
              
                  $.ajax({
                    async: false,
                    type: "post",
                    url: "/cart/change.js",
                    data: tempobj,
                    dataType: 'json',
                    success: function(cart) {
                      custom.updateCartContent(cart);
                                                 
                    },
                    error: function (xhr) {
                        if(xhr.responseText){
                        console.log(xhr.responseText);
                      }
                      
                    },
                    complete: function () {
            
                    }
                  });
               

              }else{
                  //  console.log(giftInCartArr.indexOf(fullgiftId));
                  if(giftInCartArr.indexOf(fullgiftId) == -1){ 
                    fullupdatesObj[fullgiftAvaiId] = 1;
                    custom.updateGift(fullupdatesObj);
                  }
              }              

              }else {
              // 没有gift在cart中，直接加购当前需要加购的gift即可
              var fullgiftAvaiId = $(`.fullamount-item[data-level="${currlevel}"]`).attr("data-gift-variant");
                  fullgiftObj = {id: fullgiftAvaiId ,quantity: 1};
              custom.addGift(fullgiftObj);
            }
          }else if(currlevel == 0 && hasGift && giftInCartArr.length > 0 ){
            // console.log(currlevel,hasGift,giftInCartArr.length);
            // 0级的时候如果购物车存在gift ，则删除
            let fullupdatesObj = {};

              giftInCartArr.forEach(function(giftInCartId) {
                if($(`cart-drawer-items .cart-items [data-product-id="${giftInCartId}"]`).length){
                  let tempVariantId = parseInt($(`cart-drawer-items .cart-items [data-product-id="${giftInCartId}"]`).attr(`data-idth`));
                  if(tempVariantId != fullgiftAvaiId) {
                    fullupdatesObj[tempVariantId] = 0;
                  }
                }
              
            });
            console.log(fullupdatesObj);
            custom.updateGift(fullupdatesObj);

          }else if(currlevel == 0 && !hasGift && giftInCartArr.length == 0 ){
            // console.log(cart.item_count);
            // console.log(window.designated_buy_gift_group);
            if(window.designated_buy_gift_function == true){
              if(cart.item_count== 1){ idToCheck2 = String(cart.items[0].id); }         
              if(cart.item_count== 1 && window.designated_buy_gift_group.indexOf(idToCheck2) !== -1){
                custom.clearCart();
              }
            }
          }
          custom.open_checkout();
          custom.freegift_Tips_section(currlevel, subtotalPrice);
        });
      }
    }

  }
})(jQuery);